import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "../../axiosClient/userApi";
import { TagType, TagTypeFormData } from "../../../types/tag";

export const useUpdateTagType = () => {
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: async ({ id, data }: { id: string; data: Partial<TagTypeFormData> }): Promise<TagType> => {
            const response = await loggedInApiCall.put(`/api/tag_types/${id}`, data);
            return response.data;
        },
        onSuccess: (_, { id }) => {
            queryClient.invalidateQueries(["getAllTagTypes"]);
            queryClient.invalidateQueries(["getOneTagType", id]);
        },
    });

    return mutation;
};
